const noMatch = [null, null];
export const parseCameraAndTimeUrl = (querystring: string) => {
    const [ , deviceId ] = /(?:\?|&)cam=([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})(?:&|$)/i.exec(querystring) || noMatch;
    const [ , deviceIndexString ] = /(?:\?|&)cam=(\d+)(?:&|$)/i.exec(querystring) || noMatch;
    const [ , utcTimeString ] = /(?:\?|&)t=(\d+)(?:&|$)/i.exec(querystring) || noMatch;
    if (deviceIndexString && utcTimeString) {
        const deviceIndex = parseInt(deviceIndexString, 10);
        const utcTime = parseFloat(utcTimeString);
        return {
            deviceIndex,
            utcTime,
        };
    }
    else if (deviceId && utcTimeString) {
        const utcTime = parseFloat(utcTimeString);
        return {
            deviceId: deviceId.toLowerCase(),
            utcTime,
        };
    }
    return null;
};



// WEBPACK FOOTER //
// ./src/logic/parseCameraAndTimeUrl.ts